export * from './data';
export * from './table';

export const enum EDeployEnv {
  PROD = 'production',
  STAGE = 'staging',
  DEV = 'dev',
  TEST = 'test',
  PROD_VET = 'production-vet',
}
